import React, { createContext, useContext, useState } from 'react';

const SponsorContext = createContext({ page: 0, size: 10, searchWrd: '', division: ''});

const SponsorProvider = ({ children }) => {
    const [options, setOptions] = useState({ page: 0, size: 10, searchWrd: '', division: '' });

    const value = {
        options,
        setOptions
    };

    return <SponsorContext.Provider value={value}>{children}</SponsorContext.Provider>;
};

const useSponsorContext = () => {
    return useContext(SponsorContext);
};

export { SponsorProvider, useSponsorContext };
